import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23e85734"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "parent" }
const _hoisted_2 = { class: "keyboard-row" }
const _hoisted_3 = { class: "keyboard-row" }
const _hoisted_4 = { class: "keyboard-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.firstRowLetters, (letter) => {
        return (_openBlock(), _createBlock(_component_q_btn, {
          flat: "",
          class: "keyboard-btn",
          onClick: ($event: any) => (_ctx.$emit('onLetterPressed', letter)),
          key: letter,
          style: _normalizeStyle({backgroundColor: _ctx.keyboardData.getColor(letter, this.colorBlindData.isActive)})
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(letter), 1)
          ]),
          _: 2
        }, 1032, ["onClick", "style"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.secondRowLetters, (letter) => {
        return (_openBlock(), _createBlock(_component_q_btn, {
          flat: "",
          class: "keyboard-btn",
          onClick: ($event: any) => (_ctx.$emit('onLetterPressed', letter)),
          key: letter,
          style: _normalizeStyle({backgroundColor: _ctx.keyboardData.getColor(letter, this.colorBlindData.isActive)})
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(letter), 1)
          ]),
          _: 2
        }, 1032, ["onClick", "style"]))
      }), 128)),
      _createVNode(_component_q_btn, {
        flat: "",
        class: "keyboard-btn back-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onBackPressed'))),
        style: _normalizeStyle({backgroundColor: _ctx.btnColor})
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_icon, { name: "backspace" })
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thirdRowLetters, (letter) => {
        return (_openBlock(), _createBlock(_component_q_btn, {
          flat: "",
          class: "keyboard-btn",
          onClick: ($event: any) => (_ctx.$emit('onLetterPressed', letter)),
          key: letter,
          style: _normalizeStyle({backgroundColor: _ctx.keyboardData.getColor(letter, this.colorBlindData.isActive)})
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(letter), 1)
          ]),
          _: 2
        }, 1032, ["onClick", "style"]))
      }), 128)),
      _createVNode(_component_q_btn, {
        flat: "",
        class: "keyboard-btn enter-btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onEnterPressed'))),
        style: _normalizeStyle({backgroundColor: _ctx.btnColor})
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_icon, { name: "keyboard_return" })
        ]),
        _: 1
      }, 8, ["style"])
    ])
  ]))
}